<template>
	<div class="select_veterinarian_row">
		<div class="select">
			<vSelect label="name" :options="veterinarians" v-model="selected"></vSelect>
		</div>
		<div class="actions">
			<button v-bind:class="{ disabled: !selected }" @click="openEditVeterinarianPopup()"><i class="fa-solid fa-pen-to-square"></i></button>
			<button @click="openNewVeterinarianPopup()"><i class="fa-solid fa-plus"></i></button>
		</div>
	</div>
	<vue-final-modal v-model="edit_veterinarian" classes="modal" content-class="modal_box">
		<div class="modal_title">
			<span v-if="edit_veterinarian_new">NUOVO VETERINARIO</span>
			<span v-else>MODIFICA VETERINARIO</span>
			<button class="modal_close" @click="edit_veterinarian = false">
				<i class="fas fa-times"></i>
			</button>
		</div>
		<div class="modal_content">
			<div class="modal_content_row">
				<label>Nome</label>
				<input type="text" v-model="name" />
			</div>
			<div class="modal_content_row">
				<label>Email</label>
				<input type="text" v-model="email" />
			</div>
			<div class="modal_content_row">
				<label>Recapito Telefonico</label>
				<input type="text" v-model="phone_number" />
			</div>
			<div class="modal_content_row">
				<label>Recapito di Emergenza</label>
				<input type="text" v-model="emergency_number" />
			</div>
			<div class="modal_content_row">
				<label>Città</label>
				<input type="text" v-model="city" />
			</div>
			<div class="modal_content_row">
				<button class="button" :class="{ disabled: !veterinarian_fields_ok }" @click="saveVeterinarian()">SALVA</button>
			</div>
		</div>
	</vue-final-modal>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';

export default {
	name: 'VeterinarianSelect',
	components: {
		vSelect
	},
	props: [
		'preselected'
	],
	emits: [
		'update:preselected'
	],
	data() {
		return {
			veterinarians: [],
			edit_veterinarian: false,
			edit_veterinarian_new: false,
			id: '',
			name: '',
			email: '',
			phone_number: '',
			emergency_number: '',
			city: ''
		}
	},
	computed: {
		selected: {
			get () { return this.preselected },
			set (value) { this.$emit('update:preselected', value) },
		},
		veterinarian_fields_ok: function() {
			if(this.name == '') {
				return false
			} else {
				return true
			}
		}
	},
	methods: {
		getVeterinarians: function() {
			var self = this

			self.loading = true

			self.axios.get(
				self.$store.state.base_url + '/api/veterinarians/all',
				{
					headers: { Authorization: `Bearer ${self.$store.state.token}` }
				}
			).then(function(response) {
				self.veterinarians = response.data;
				self.loading = false
			})
		},
		openNewVeterinarianPopup: function() {
			this.id = 0
			this.name = ''
			this.email = ''
			this.phone_number = ''
			this.emergency_number = ''
			this.city = ''
			this.edit_veterinarian_new = true
			this.edit_veterinarian = true
		},
		openEditVeterinarianPopup: function() {
			this.id = this.selected.ID
			this.name = this.selected.name
			this.email = this.selected.email
			this.phone_number = this.selected.phone_number
			this.emergency_number = this.selected.emergency_number
			this.city = this.selected.city
			this.edit_veterinarian_new = false
			this.edit_veterinarian = true
		},
		saveVeterinarian: function() {
			var self = this

			self.axios.post(
				self.$store.state.base_url + '/api/veterinarians/edit/' + self.id,
				{
					'name': self.name,
					'email': self.email,
					'phone_number': self.phone_number,
					'emergency_number': self.emergency_number,
					'city': self.city
				},
				{
					headers: { Authorization: `Bearer ${self.$store.state.token}` }
				}
			).then(function(response) {
				self.edit_veterinarian = false
				self.getVeterinarians()

				let new_selected = {
					ID: '',
					name: '',
					email: '',
					phone_number: '',
					emergency_number: '',
					city: ''
				}

				if(self.id > 0) {
					new_selected.ID = self.id
				} else {
					new_selected.ID = response.data
				}
				new_selected.name = self.name
				new_selected.email = self.email
				new_selected.phone_number = self.phone_number
				new_selected.emergency_number = self.emergency_number
				new_selected.city = self.city

				self.selected = new_selected;
			})
		}
	},
	mounted: function() {
		this.getVeterinarians()
	}
}
</script>

<style type="text/css" scoped>
	.select_veterinarian_row {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.select {
		flex: 1;
	}

	.actions {
		min-width: 90px;
		max-width: 90px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-left: 20px;
	}

	.actions button {
		background: #5e72e4;
		border-radius: 50%;
		width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 2px solid #5e72e4;
		outline: none;
		cursor: pointer;
		margin-left: 5px;
	}

	.actions button:first-child {
		margin-left: 0px;
	}

	.actions button i {
		padding: 0;
		margin: 0;
		color: #fff;
		font-size: 20px;
	}

	.actions button:first-child i {
		font-size: 16px;
	}

	.actions button:hover {
		background: #fff;
	}

	.actions button:hover i {
		color: #5e72e4;
	}

	.actions button.disabled {
		opacity: 0.5;
		filter: grayscale(1);
		pointer-events: none;
	}
</style>